import { CheckInputButton } from '../../components/CheckInputButton'
import { TorchApplicationSubmissionHeader } from '../../components/TorchApplicationSubmissionHeader'

export const Page1Skeleton = () => {
  return (
    <>
      <TorchApplicationSubmissionHeader disabled={true} onNext={() => {}} />
      <div className="flex flex-col items-center gap-8">
        <div className="h-[46px] w-1/2 animate-pulse rounded-lg bg-gray-300" />

        <div className="flex flex-col items-stretch gap-4 md:flex-row">
          <CheckInputButton.Skeleton />
          <CheckInputButton.Skeleton />
        </div>
      </div>
    </>
  )
}
